import React  from 'react';  

export const clinicalDocumentConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        path: '/clinical-document',
        component: React.lazy(() => import('./MyClinicalDocument')),
      },
    ],
  },
 
];

